import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AccessibilityClickableDiv, AccessibilityHiddenImg } from '@skillz/accessibility';
import Icon from "../../../shared/components/ui/icons/Icon";
import iconsList from "../../../shared/components/ui/icons/iconsList"
import pathRouts from "../../../shared/enums/pathRoute";
import Support from "../../../shared/components/features/support/Support";
import Faq from "../tabs/faq/Faq";
import TranslateBtns from "../../../shared/components/ui/translateBtns/TranslateBtns";
import SimplePopup from "../../../shared/components/ui/popup/simplePopup/SimplePopup";
import ScrollLTR from "../../../shared/components/ui/scrollLTR/ScrollLTR";
import useClickOutside from "../../../shared/hooks/useClickOutside";
import virtualCampusLogoLogout from "../../../assests/notAuth/virtualCampusLogoLogout.png";
import classes from "./HeaderLogout.module.css"


const HeaderLogout = () => {

    const [showFaq, setShowFaq] = useState()
    const { texts, lang } = useSelector(state => state.translate);
    const accessibilityLink = useSelector(state => state?.uiData?.general?.accessibilityLink)
    const faqRef = useRef()
    const navigate = useNavigate();
    
    useClickOutside(faqRef, () => {
        setShowFaq(false)
    });

    return (
        <div className={classes.HeaderWrapper}>
            <div className={classes.Header}>
                <div className={classes.HeaderTabsAndLogo}>

                    <div className={`${classes.Logos} ${classes[lang]}`}>
                        <AccessibilityClickableDiv onClick={() => navigate(pathRouts.HOME)} className={classes.VirtualCampusLogo} accessibilityDescription={texts.virtualCampus}>
                            <AccessibilityHiddenImg src={virtualCampusLogoLogout} />
                        </AccessibilityClickableDiv>
                    </div>

                </div>
                <div className={classes.Tabs}>
                    <TranslateBtns />
                    <Icon name={iconsList.accessibility} size="36px" color="#979797" className={classes.Accessibility} accessibilityDescription={texts.accessibilityStatementLink} onClick={() => window.open(accessibilityLink?.[lang], '_blank', 'noopener,noreferrer')} />
                    <div className={`${classes.Faq} ${showFaq ? classes.Active : ''}`} ref={faqRef}>
                        <Icon name={iconsList.faq} size="26px" color="#979797" className={classes.FaqIcon} accessibilityDescription={texts.faq} onClick={() => setShowFaq(prev => !prev)}/>
                        {showFaq && (
                            <SimplePopup anchored close={() => setShowFaq(false)} dropClassContainer={classes.FaqAnchoredContainer} accessibilityDescription={texts.faq}>
                                <div className={classes.FaqAnchoredContent}>
                                    <Icon className={classes.FaqClose} size="30px" name={iconsList.close} onClick={() => setShowFaq(false)}/>
                                    <ScrollLTR height="100%" dropClass={classes.FaqScroll} downDropStyle={classes.FaqScrollInner}>
                                        <Faq />
                                    </ScrollLTR>
                                </div>
                            </SimplePopup>
                        )}
                    </div>
                    <div className={classes.Support}>
                        <Support />
                    </div>
                </div>
            </div>
        </div >
    )
}
export default HeaderLogout;